export default "__VITE_ASSET__C96DVi2T__"